import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { AuthService } from '../../services/auth.service';

/** The newest Optimus Desktop installer (wd-desktop: npm run release -- --publish puts it there). */
const DESKTOP_DOWNLOAD = 'https://d2ubjh8xvbul5m.cloudfront.net/mac/Optimus-arm64.dmg';

/** The signed-in console: the header with the section tabs, and the page under it. */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: ['full.component.css'],
})
export class FullComponent {
  readonly desktopDownload = DESKTOP_DOWNLOAD;

  /** Hides admin-only tabs from people who cannot use them. Cosmetic: the API enforces access. */
  readonly isAdmin$: Observable<boolean>;

  constructor(public menu: MenuItems, private router: Router, auth: AuthService) {
    this.isAdmin$ = auth.isAdmin$;
  }

  /** The Authoring tab is a menu, so it is lit for any of its pages. */
  inAuthoring(): boolean {
    return this.menu.authoring.some((item) => this.router.url.startsWith(`/admin/${item.state}`));
  }
}
